module.exports = __webpack_public_path__ + "img/kirinsushioverview.de72c76b.jpg";